var _excluded = ["size", "loading", "disabled", "children", "elevated", "m", "mx", "my", "mr", "ml", "mt", "mb"],
    _excluded2 = ["disabled", "elevated", "children", "m", "mx", "my", "mr", "ml", "mt", "mb"];

var _labelFont;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { cloneElement } from 'react';
import styled from 'styled-components';
import Loader from '../../../components/Loader/Loader';
import StyledButton, { ButtonSize } from '../../Buttons';
import Text from '../../Text';
import InteractWrapper from '../InteractWrapper';
import useTheme from '../../../useTheme';
var StyledText = styled.span.withConfig({
  displayName: "ButtonHoc__StyledText",
  componentId: "sc-q9g3nl-0"
})(["position:relative;z-index:1;display:flex;align-items:center;"]);
var labelFont = (_labelFont = {}, _defineProperty(_labelFont, ButtonSize.Large, Text.Label18), _defineProperty(_labelFont, ButtonSize.Medium, Text.Label16), _defineProperty(_labelFont, ButtonSize.Small, Text.Label14), _labelFont);
export function ButtonHoc(config) {
  return function Button(props) {
    var _useTheme = useTheme(),
        colors = _useTheme.colors,
        shadows = _useTheme.shadows;

    var _props$size = props.size,
        size = _props$size === void 0 ? ButtonSize.Large : _props$size,
        loading = props.loading,
        disabled = props.disabled,
        children = props.children,
        elevated = props.elevated,
        m = props.m,
        mx = props.mx,
        my = props.my,
        mr = props.mr,
        ml = props.ml,
        mt = props.mt,
        mb = props.mb,
        rest = _objectWithoutProperties(props, _excluded);

    var isDisabled = loading || disabled;
    var textColor = isDisabled ? config.textColorDisabled : config.textColorDefault;
    return /*#__PURE__*/React.createElement(InteractWrapper, {
      size: size,
      disabled: isDisabled,
      elevated: elevated,
      shadowType: shadows[config.shadowType],
      rippleColor: config.rippleColor,
      m: m,
      mx: mx,
      my: my,
      mr: mr,
      ml: ml,
      mt: mt,
      mb: mb
    }, /*#__PURE__*/React.createElement(StyledButton, _extends({
      as: 'button',
      type: 'button',
      size: size,
      disabled: isDisabled,
      mainBgColor: colors[config.bgColorDefault],
      hoverBgColor: colors[config.bgColorHover],
      disabledBgColor: colors[config.bgColorDisabled]
    }, rest), loading ? /*#__PURE__*/React.createElement(Loader, {
      color: colors[config.loaderColor]
    }) : /*#__PURE__*/React.createElement(StyledText, {
      color: textColor,
      as: labelFont[size],
      forwardedAs: "span"
    }, children)));
  };
}
export function IconButtonHoc(config) {
  return function IconButton(props) {
    var _useTheme2 = useTheme(),
        colors = _useTheme2.colors,
        shadows = _useTheme2.shadows;

    var disabled = props.disabled,
        elevated = props.elevated,
        children = props.children,
        m = props.m,
        mx = props.mx,
        my = props.my,
        mr = props.mr,
        ml = props.ml,
        mt = props.mt,
        mb = props.mb,
        rest = _objectWithoutProperties(props, _excluded2);

    var iconColor = disabled ? config.textColorDisabled : config.textColorDefault;
    return /*#__PURE__*/React.createElement(InteractWrapper, {
      width: "s56",
      disabled: disabled,
      elevated: elevated,
      shadowType: shadows[config.shadowType],
      rippleColor: colors[config.rippleColor],
      rippleSize: 7,
      rippleMultiplier: 10,
      m: m,
      mx: mx,
      my: my,
      mr: mr,
      ml: ml,
      mt: mt,
      mb: mb
    }, /*#__PURE__*/React.createElement(StyledButton, _extends({
      as: 'button',
      type: 'button',
      disabled: disabled,
      mainBgColor: colors[config.bgColorDefault],
      hoverBgColor: colors[config.bgColorHover],
      disabledBgColor: colors[config.bgColorDisabled],
      color: colors[iconColor],
      isIconButton: true
    }, rest), /*#__PURE__*/React.createElement(StyledText, null, /*#__PURE__*/cloneElement(children, {
      color: iconColor,
      size: 's24'
    })), /*#__PURE__*/React.createElement(Text.Label12, {
      as: "span",
      screenReaderOnly: true
    }, props.label)));
  };
}